<template>
  <div class="w-full">
    <div class="sticky top-0 z-10 flex items-center justify-between h-16 px-4 bg-white border-b lg:px-6">
      <h1 class="text-lg font-bold">
        Addresses
      </h1>
      <router-link :to="{ name: 'CustomerAddressCreate' }" class="btn btn-accent">
        Add Address
      </router-link>
    </div>

    <Loading v-if="loading" class="p-8" />
    
    <div v-else>
      <!-- No Results -->
      <div v-if="addresses.meta.total < 1" class="px-6 py-12 text-center text-gray-500">
        You don't have any addresses yet.
      </div>

      <!-- Results -->
      <div v-else>
        <!-- List -->
        <div class="divide-y">
          <div class="hidden gap-4 px-4 py-3 text-xs font-medium tracking-wide text-gray-500 uppercase lg:px-6 bg-gray-50 lg:grid lg:grid-cols-3">
            <div>
              Contact
            </div>
            <div>
              Address
            </div>
          </div>
          <div v-for="address in addresses.data" :key="address.id" class="grid grid-flow-row gap-4 px-4 py-4 text-gray-800 lg:px-6 sm:grid-cols-3 lg:grid-flow-col">
            <div>
              <span class="font-medium">{{ address.name }}</span> <br>
              {{ address.contact_name }} <br>
              {{ address.contact_phone }} <br>
              {{ address.contact_email }}
            </div>
            <div>
              {{ address.address_1 }} {{ address.address_2 }} <br>
              {{ address.city }} <br>
              {{ address.zip }} <br>
              {{ address.country }}
            </div>
            <div class="lg:text-right">
              <router-link :to="{ name: 'CustomerAddressEdit', params: { id: address.id } }" class="btn btn-sm">
                Edit Address
              </router-link>
            </div>
          </div>
        </div>
        <!-- Pagination -->
        <Pagination class="border-t rounded-b-lg" :total="addresses.meta.total" :per-page="addresses.meta.per_page" :current-page="addresses.meta.current_page" />
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'CustomerAddressList',

  created () {
    this.getAddresses()
  },

  data () {
    return {
      loading: true,
      addresses: {},
      filter: {
        search: ''
      }
    }
  },

  methods: {
    async getAddresses () {
      try {
        const { data } = await this.$api.get(`portal/${this.$store.state.portal.subdomain}/customer/addresses/`, {
          params: {
            page: this.$route.query.page || 1,
            sort: this.$route.query.sort || 'name',
            dir: this.$route.query.dir || 'desc',
            filter: this.filter
          }
        })
        this.addresses = data.addresses
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  },

  watch: {
    '$route.query': {
      handler (newVal, oldVal) {
        this.getAddresses()
      },
      deep: true
    }
  }
}
</script>

